import { TRANSACTION_HISTORY_REQUEST, TRANSACTION_HISTORY_SUCCESS, TRANSACTION_HISTORY_FAILURE } from "./types"

export const transactionhistoryRequest = () => {
    return {
        type: TRANSACTION_HISTORY_REQUEST
    }
}

export const transactionhistorySuccess = cred => {
    return {
        type: TRANSACTION_HISTORY_SUCCESS,
        payload: cred
    }
}

export const transactionhistoryFailure = error => {
    return {
        type: TRANSACTION_HISTORY_FAILURE,
        payload: error
    }
}